import React from 'react';
import { siteConfig } from '../data/config';
import AppHero from '../components/AppHero';
import AppFeatures from '../components/AppFeatures';
import AppContact from '../components/AppContact';

function WaterTrack() {
  const app = siteConfig.apps.find(app => app.id === 'water-track');

  return (
    <div className="water-track-page">
      <AppHero
        title={app.title}
        subtitle="Stay Hydrated, Stay Healthy"
        description="A simple and intuitive mobile application designed to help you track your daily water intake and maintain healthy hydration habits. Available on iOS and Android devices."
        icon={app.icon}
        showStoreButtons={true}
        storeUrls={app.storeUrls}
        storeVisibility={app.storeVisibility}
      />

      <AppFeatures features={app.features} />

      <section className="app-screenshots">
        <div className="container">
          <h2 className="section-title">App Screenshots</h2>
          <div className="screenshots-grid">
            <div className="screenshot-item">
              <img 
                src="/images/water-track/WaterTrack1.png" 
                alt="Water Track - Main Screen" 
                className="screenshot-image"
              />
              <p className="screenshot-caption">Main Screen</p>
            </div>
            <div className="screenshot-item">
              <img 
                src="/images/water-track/WaterTrack2.png" 
                alt="Water Track - Daily Goal Achievement" 
                className="screenshot-image"
              />
              <p className="screenshot-caption">Daily Goal Achievement</p>
            </div>
            <div className="screenshot-item">
              <img 
                src="/images/water-track/WaterTrack3.png" 
                alt="Water Track - Reports Screen" 
                className="screenshot-image"
              />
              <p className="screenshot-caption">Reports Screen</p>
            </div>
            <div className="screenshot-item">
              <img 
                src="/images/water-track/WaterTrack4.png" 
                alt="Water Track - Settings Screen" 
                className="screenshot-image"
              />
              <p className="screenshot-caption">Settings Screen</p>
            </div>
          </div>
        </div>
      </section>

      <section className="app-purpose">
        <div className="container">
          <h2 className="section-title">Why Water Tracking?</h2>
          <div className="purpose-content">
            <p>
              Proper hydration is essential for maintaining good health, but many people struggle to drink enough water throughout the day. 
              Water Track Daily H2O was created to solve this common problem by providing a simple, intuitive way to monitor daily water intake.
            </p>
            <p>
              The app helps users develop healthy hydration habits by providing visual feedback, gentle reminders, and progress tracking. 
              Whether you're trying to meet a specific health goal or simply want to ensure you're staying properly hydrated, 
              this app makes it easy to stay on track.
            </p>
            <div className="benefits-list">
              <h3>Health Benefits of Proper Hydration:</h3>
              <ul>
                <li>Improved energy levels and mental clarity</li>
                <li>Better physical performance and recovery</li>
                <li>Enhanced skin health and appearance</li>
                <li>Proper digestion and nutrient absorption</li>
                <li>Regulated body temperature</li>
                <li>Reduced risk of kidney stones and urinary tract infections</li>
              </ul>
            </div>
          </div>
        </div>
      </section>


      <AppContact appName={app.title} privacyLink={app.privacyLink} tosLink={app.tosLink} />
    </div>
  );
}

export default WaterTrack;
